module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("hgFWX"))).then(() => parcelRequire('hEqeo'));